import React from 'react';
import { Box, Typography } from '@mui/material';
import useInterveneSx from '../../hooks/useInterveneSx';
import { formatMessageDateSeparator } from '../../utils/messageDateUtils';

export default function ChatDateSeparator({ dateValue }) {
  const styles = useInterveneSx().messageFeed;
  const label = formatMessageDateSeparator(dateValue);

  if (!label) return null;

  return (
    <Box sx={styles.dateSeparator} role="separator" aria-label={label}>
      <Box sx={styles.dateSeparatorLine} />
      <Typography component="span" sx={styles.dateSeparatorLabel}>
        {label}
      </Typography>
      <Box sx={styles.dateSeparatorLine} />
    </Box>
  );
}
